export default __webpack_public_path__ + "static/media/ies_Agenda_ENG.87f572be.png";